import { RootState } from 'src/store';

import { IFilterData } from './types';

export const selectFiltersListData = (state: RootState): IFilterData => state.filters.data;
export const selectFiltersLoading = (state: RootState): boolean => state.filters.isLoading;
export const selectFiltersLoaded = (state: RootState): boolean => state.filters.isLoaded;
